module.exports = __webpack_public_path__ + "media/images/landing_page/2023/album/album_mobile_lv-4376a858a4bb652df6a92d300897fc7b.webp";